/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApPageNavbar = /** @class */ (function () {
            function ApPageNavbar() {
                this.replace = false;
                this.restrict = 'E';
                this.scope = {};
                this.templateUrl = 'app/directives/ap-page-navbar/template.html';
                this.controller = Directives.ApPageNavbarController;
                this.controllerAs = 'ctrl';
            }
            ApPageNavbar.factory = function () {
                var directive = function () {
                    return new ApPageNavbar();
                };
                directive['$inject'] = [];
                return directive;
            };
            return ApPageNavbar;
        }());
        angular
            .module('app.Directives')
            .directive('apPageNavbar', ApPageNavbar.factory());
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
